import { Component, Inject, ChangeDetectorRef, Output, EventEmitter, Input } from "@angular/core";
import { AbstractPopupComponent } from "../../../../shared/components/popup/abstractPopupComponent";
import { PopupService, MessageBoxConfig } from "../../../../shared/components";

@Component({
  selector: "schedule-change-popup",
  templateUrl: "./scheduleChangePopupComponent.html"
})
export class ScheduleChangePopupComponent extends AbstractPopupComponent {

  public scheduleChangeData: ScheduleChangeData;
  public dateToday: Date;
  public selectedDate: Date;
  public message: string = "Select the desired date to schedule the change on.";

  @Output()
  onOkClick = new EventEmitter();
  constructor(
    @Inject(PopupService) public popupService: PopupService,
    public cdr: ChangeDetectorRef
  ) {
    super(cdr, popupService);
  }

  public open(data: ScheduleChangeData) {
    this.scheduleChangeData = data;
    this.selectedDate = this.dateToday = new Date();
    this.showInternal();
  }

  public okClick() {
    this.scheduleChangeData.date = this.selectedDate.toLocaleDateString('sv-EN');
    this.onOkClick.emit(this.scheduleChangeData);
  }
}

export interface ScheduleChangeData {
  date?: string;
  productId?: string;
  product?: string;
  priceListCategory?: string;
  priceListCategoryId?: string;
  type: string;
  user: string;
}